import React, { Component } from "react";
import ReactS3Uploader from "react-s3-uploader";
import {
  ActionButton,
  DefaultButton,
  IButtonProps
} from "office-ui-fabric-react/lib/Button";
import { Label } from "office-ui-fabric-react/lib/Label";

class FileUploader extends Component {
  render() {


    return (
      <div className="upload-btn-wrapper">
        <DefaultButton 
          primary 
          text="Upload" 
          iconProps={ { iconName: 'Cloud' } }          />
        <ReactS3Uploader
          // style={{ display: "none" }}
          multiple
          className="ms-Button"
          signingUrl="/s3/sign"
          signingUrlMethod="GET"
          accept="file/*"
          s3path="/uploads/"
          // preprocess={this.onUploadStart}
          // onSignedUrl={this.onSignedUrl}
          // onProgress={this.onUploadProgress}
          // onError={this.onUploadError}
          onFinish={this.props.handleFinishUpload}
          // signingUrlHeaders={{ additional: headers }}
          // signingUrlQueryParams={{ additional: query - params }}
          // signingUrlWithCredentials={true} // in case when need to pass authentication credentials via CORS
          // uploadRequestHeaders={{ "x-amz-acl": "public-read" }} // this is the default
          // contentDisposition="auto"
          scrubFilename={filename => filename.replace(/[^\w\d_\-.]+/gi, "")}
          // server={'http://192.168.1.20:5000'}
          server={'https://apiv1.colourrush.nl'}
          // inputRef={cmp => (this.uploadInput = cmp)}
          autoUpload={true}
        />
      </div>
    );
  }
}

export default FileUploader;



// WEBPACK FOOTER //
// ./src/common/_FileUploader.js